<template>
  <div class="user-manage-constructor main-body">
    <!-- <div class="button-search-body">
      <div class="search-body">
        <div class="button-body">
          <ButtonList 
            :list="buttonList"
            :target="buttonTarget"
          />
        </div>
      </div>
    </div> -->
    <div class="table-body">
      <TableCom
        :tableList="tableList"
        :tableProps="tableProps"
      ></TableCom>
    </div>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.limit"
      />
    </div>
    <AddUrl
      v-if="addUrlFlag"
      :target="addUrlTarget"
      :title="title"
      @close="urlFlagClose"
      @refresh="selectList" />
    <UserEdit
      v-if="userEditTarget"
      :target="userEditTarget"
      @close="userEditTargetChange(undefined)"
      @submitCallback="selectList"
    ></UserEdit>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, toRaw
} from 'vue'
import { isNull, dayjs, message } from '@/utils/js/initVariable'
import TableCom from '@/components/TableCom'
import Pagination from '@/components/Pagination'
import ButtonList from '@/components/ButtonList'
import {
  ElLoading, ElMessageBox, ElImageViewer,
} from 'element-plus'
import { queryPageList, deleteMap} from '@/api/MapManage'
import AddUrl from '@/views/UrlManage/component/addurl'
import UserEdit from './component/UserEdit';

// props
const props = defineProps({
  
})
// emit
const emit = defineEmits([
  
])

const userEditTarget = ref(),
      userEditTargetChange = (target)=>{
        userEditTarget.value = target;
      }

const userEditFn = (target, button, loadFn)=>{
  userEditTarget.value = Object.assign({}, target, {
    polygonUserList: (target['userList'] || []).map(item=>{
      return item['userId'];
    })
  });
  console.log(userEditTarget.value);
  loadFn && loadFn()
}

const addUrlFlag = ref(false)
const addUrlTarget = ref(undefined)
const title = ref('')
const addFun = (target, button, loadFn) => {
  addUrlFlag.value = true
  title.value = '添加底图服务'
  addUrlTarget.value = { ...target }
  loadFn()
}
const urlFlagClose = () => {
  addUrlTarget.value = ''
  addUrlFlag.value = false
}

const searchFun = (target, button, loadFn) => {
  selectList()
  loadFn()
}

const editUrl = (target, button, loadFn) => {
  addUrlFlag.value = true
  title.value = '编辑底图服务'
  addUrlTarget.value = { ...target }
  loadFn()

}
const deleteUrl = async(target, button, loadFn) => {
  const confirmation = await ElMessageBox.confirm(
      '是否删除该服务？',
      '确认删除',
      {
        confirmButtonText: '删除并关闭',
        cancelButtonText: '取消删除',
        type: 'warning'
      }
    ).catch((err) => {
      console.log(err)
    })
    if (confirmation) {
      deleteMap(target.id).then(res=>{
      if(res.data.code == 1004){
        message('删除成功', 1)
        selectList()
      }
    })
  }
  loadFn()
  return 
}

// 需要序号可添加
const tableNumber = (number)=>{
  return (listQuery.page-1) * listQuery.limit + number;
}
const tableProps = ref([
  { label: '序号', fun: tableNumber, fixed: true, },
  { label: 'ID', prop: 'id', },
  { label: '图层名', prop: 'layerName', },
  { label: '图层类型', prop: 'layerType', },
  { label: '坐标系', prop: 'layerCoordinate', },
  { label: '最小缩放', prop: 'layerZoomMin', },
  { label: '最大缩放', prop: 'layerZoomMax', },
  { label: '发布模式', prop: 'layerMode', },
  // { label: '图层URL', prop: 'layerUrl', },
  { label: '时间类型', prop: 'timeType', },
  { label: '开始时间', prop: 'layerDataStartDate', },
  { label: '结束时间', prop: 'layerDataEndDate', },
  { label: '操作', 
    buttonList: [
      { name: '用户分配', icon: 'el-User', fun: userEditFn, type: 'primary' },
      { name: '修改', icon: 'el-Edit', fun: editUrl, type: 'warning' },
      { name: '删除', icon: 'el-Delete', fun: deleteUrl, type: 'danger' },
    ]
  }
])

const buttonTarget = ref({});
const buttonList = ref([
  { name: '添加底图服务', icon: 'el-Plus', type: 'primary', fun: addFun },
])

const tableList = ref([])
let total = ref(0),
    listQuery = reactive({
      page: 1,
      limit: 20
    })
// 分页器change
const pageChange = ()=>{
  selectList()
}

const selectList = ()=>{
  // console.log(listQuery);
  let load = ElLoading.service({
    lock: true,
    target: '.main-body',
    background: 'var(--loadBackColor)'
  })

  const params = {
    pager: {
      page: listQuery.page,
      length: listQuery.limit,
      start: (listQuery.page - 1) * listQuery.limit
    }
  }

  queryPageList(params).then(res=>{
    // console.log('queryPageList params',params)
    if(res.data.code == 1004){
    // console.log('tableList',res.data.dataList)
      tableList.value = res.data.dataList;
      total.value = res.data.totalCount || 0;
    }
    load.close()
  }).catch(err=>{
    load.close()
    console.log(err)
  })
}
// 组件挂载前
onBeforeMount(()=>{

})
// 组件挂载后
onMounted(()=>{
  selectList()
})
// 组件更新后
onUpdated(()=>{

})
// 组件销毁后
onUnmounted(()=>{

})

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.user-manage-constructor {
  padding: 10px;
  --h3Height: 30px;
  
}
</style> 